export default __webpack_public_path__ + "media/zurb/img/services/services/web-application-img-caef6b95a7e65080b764d99d7b70c310.png";